'use client'

import type { CSSProperties } from 'react'

type LogoLoginProps = {
  style?: CSSProperties
}

const LogoLogin = ({ style }: LogoLoginProps) => {
  return (
    <div className='flex items-center min-bs-[24px]' style={style}>
      <div className='bg-white p-4 rounded-lg transition duration-150 ease-in-out hover:scale-110'>
        <img src='/images/icon/logo.png' alt='logo' width={150} height={65} />
      </div>
    </div>
  )
}

export default LogoLogin
